"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "../ui/pagination";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { cn } from "@/lib/utils";
interface CustomPaginationProps {
  totalPages: number;
  currentPage: number;
  totalItems?: number;
  className?: string;
}
export function CustomPagination(t0) {
  const $ = _c(24);
  const {
    totalPages,
    currentPage,
    totalItems,
    className
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("perPage") || "5";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const perPage = parseInt(t1, 10);
  const showPerPageSelector = totalItems !== undefined ? totalItems > 5 : true;
  const showPagination = totalPages > 1;
  if (!showPagination && !showPerPageSelector) {
    return null;
  }
  let t2;
  if ($[2] !== pathname || $[3] !== searchParams) {
    t2 = pageNumber => {
      const params = new URLSearchParams(searchParams);
      params.set("page", pageNumber.toString());
      return `${pathname}?${params.toString()}`;
    };
    $[2] = pathname;
    $[3] = searchParams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const createPageURL = t2;
  let t3;
  if ($[5] !== pathname || $[6] !== router || $[7] !== searchParams) {
    t3 = value => {
      if (!value) {
        return;
      }
      const params_0 = new URLSearchParams(searchParams.toString());
      params_0.set("perPage", value);
      params_0.set("page", "1");
      router.replace(`${pathname}?${params_0.toString()}`, {
        scroll: false
      });
    };
    $[5] = pathname;
    $[6] = router;
    $[7] = searchParams;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handlePerPageChange = t3;
  const getPageRange = _temp2;
  let t4;
  if ($[9] !== className || $[10] !== createPageURL || $[11] !== currentPage || $[12] !== handlePerPageChange || $[13] !== perPage || $[14] !== showPagination || $[15] !== showPerPageSelector || $[16] !== totalPages) {
    const pageRange = getPageRange(currentPage, totalPages);
    let t5;
    if ($[18] !== className) {
      t5 = cn("mt-4 flex w-full flex-col gap-4 transition-opacity duration-200 sm:flex-row sm:items-center sm:justify-between", className);
      $[18] = className;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    let t6;
    if ($[20] !== handlePerPageChange || $[21] !== perPage || $[22] !== showPerPageSelector) {
      t6 = showPerPageSelector && <div className="text-muted-foreground flex items-center justify-center gap-2 text-sm sm:justify-start"><span>Events per page:</span><Select value={String(perPage)} onValueChange={handlePerPageChange}><SelectTrigger className="h-8 w-18 text-xs" aria-label="Pagination Per Page"><SelectValue /></SelectTrigger><SelectContent alignItemWithTrigger={false} align="center"><SelectGroup>{["5", "10", "15", "20", "25"].map(_temp3)}</SelectGroup></SelectContent></Select></div>;
      $[20] = handlePerPageChange;
      $[21] = perPage;
      $[22] = showPerPageSelector;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t4 = <div className={t5}>{t6}{showPagination ? <Pagination className="mx-0 w-auto justify-center sm:justify-end"><PaginationContent><PaginationItem>{currentPage > 1 ? <PaginationPrevious href={createPageURL(currentPage - 1)} /> : <PaginationPrevious href="#" onClick={_temp4} className="pointer-events-none opacity-70" />}</PaginationItem>{pageRange.map((page, index) => {
            if (page === "ellipsis") {
              return <PaginationItem key={`ellipsis-${index}`}><PaginationEllipsis /></PaginationItem>;
            }
            const pageNum = page as number;
            return <PaginationItem key={pageNum}><PaginationLink href={createPageURL(pageNum)} isActive={currentPage === pageNum}>{pageNum}</PaginationLink></PaginationItem>;
          })}<PaginationItem>{currentPage < totalPages ? <PaginationNext href={createPageURL(currentPage + 1)} /> : <PaginationNext href="#" onClick={_temp5} className="pointer-events-none opacity-70" />}</PaginationItem></PaginationContent></Pagination> : <div className="hidden sm:block" />}</div>;
    $[9] = className;
    $[10] = createPageURL;
    $[11] = currentPage;
    $[12] = handlePerPageChange;
    $[13] = perPage;
    $[14] = showPagination;
    $[15] = showPerPageSelector;
    $[16] = totalPages;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
function _temp5(e_0) {
  return e_0.preventDefault();
}
function _temp4(e) {
  return e.preventDefault();
}
function _temp3(val) {
  return <SelectItem key={val} value={val}>{val}</SelectItem>;
}
function _temp2(current, total) {
  const range = [];
  const leftSiblingIndex = Math.max(current - 1, 1);
  const rightSiblingIndex = Math.min(current + 1, total);
  const shouldShowLeftDots = leftSiblingIndex > 2;
  const shouldShowRightDots = rightSiblingIndex < total - 1;
  if (total <= 5) {
    for (let i = 1; i <= total; i++) {
      range.push(i);
    }
    return range;
  }
  if (!shouldShowLeftDots && shouldShowRightDots) {
    const leftRange = Array.from({
      length: 5
    }, _temp);
    return [...leftRange, "ellipsis", total];
  }
  if (shouldShowLeftDots && !shouldShowRightDots) {
    const rightRange = Array.from({
      length: 5
    }, (__0, idx_0) => total - 5 + 1 + idx_0);
    return [1, "ellipsis", ...rightRange];
  }
  if (shouldShowLeftDots && shouldShowRightDots) {
    const middleRange = Array.from({
      length: rightSiblingIndex - leftSiblingIndex + 1
    }, (__1, idx_1) => leftSiblingIndex + idx_1);
    return [1, "ellipsis", ...middleRange, "ellipsis", total];
  }
  return range;
}
function _temp(_, idx) {
  return idx + 1;
}